import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import * as ActionCable from 'actioncable';

@Injectable()
export class ActionCableService {
  /**
   * Actioncable object obtainer on creating consumer
   * @type {any}
   */
  cableObject: any;

  /**
   * Promise which resolves into cable object
   * @type {Promise<any>}
   */
  cablePromise: Promise<any>;

  /**
   * Constructor
   */
  constructor() {}

  /**
   * Function which returns promise which resolves to cable object
   * @return {Promise<any>} Promise which resolves into cable object
   */
  cable(): Promise<any> {
    if (!this.cablePromise)
      this.cablePromise = new Promise((resolve, reject) => {
        if (!this.cableObject) {
          if (environment.actioncable_url) this.cableObject = ActionCable.createConsumer(environment.actioncable_url || '');
          else this.cableObject = ActionCable.createConsumer();
        }
        console.log('Creating Action cable consumer', this.cableObject);
        resolve(this.cableObject);
      });
    return this.cablePromise;
  }

  /**
   * Reset cable by creating a new consumer
   * @return {Promise<any>} Promise which resolves into cable object
   */
  resetCable(): Promise<any> {
    console.log('Resetting Action cable');
    this.cableObject = null;
    return this.cable();
  }
}
